import { Row } from 'antd';
import React from 'react'

const tableFooterComponent = () => {
    let emailArray = ['Enviado', 'Não enviado'];
    let statusArray = [
        { label: 'Elaboração', color: 'yellow' },
        { label: 'Liberada', color: 'green' },
        { label: 'Negociação', color: 'purple' },
        { label: 'Cancelada', color: 'red' },
        { label: 'Substituída', color: 'black' },
        { label: 'Aprovada', color: 'blue' },
    ];

    return (
        <div>

            <Row>
                <div style={{ clear: 'both', paddingBottom: 20 }}>
                    <div style={{ float: 'left', marginRight: 10 }}>
                        <b>E-mail: </b>
                    </div>
                    {
                        emailArray.map(el => {
                            let color = null

                            switch (el) {
                                case 'Enviado':
                                    color = 'green'
                                    break

                                case 'Não enviado':
                                    color = 'red'
                                    break

                                default:
                                    color = null
                            }

                            return (
                                <div style={{ float: 'left', marginRight: 30 }} key={el}>
                                    <div
                                        style={{ float: 'left', backgroundColor: color, width: '15px', height: '15px', margin: 'auto', marginBottom: '5px', marginRight: 5, borderRadius: '50%' }}
                                    /> {el}
                                </div>
                            )
                        })
                    }
                </div>
            </Row>
            <Row>
                <div style={{ clear: 'both', paddingBottom: 20 }}>
                    <div style={{ float: 'left', marginRight: 10 }}>
                        <b>Status: </b>
                    </div>
                    {
                        statusArray.map(el => {
                            return (
                                <div style={{ float: 'left', marginRight: 30 }} key={el.label}>
                                    <div
                                        style={{
                                            float: 'left', backgroundColor: el.color,
                                            width: '15px', height: '15px', lineHeight: '15px',
                                            margin: 'auto', marginBottom: '5px', marginRight: 5,
                                            borderRadius: '50%',
                                        }}
                                    />
                                    {el.label}
                                </div>
                            )
                        })
                    }

                </div>
            </Row>
        </div>
    )
}

export default tableFooterComponent
